import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";

let myModal = {};

export default function ModalDeletedPrice(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });

  useEffect(() => {
    console.log("Deleted price modal On mount :", props);
    let myModal1 = document.getElementById("DeletePriceModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.data.is_open) {
      console.log("Deleted price modal On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("DeletePriceModal"),
        {}
      );
      myModal.show();
    }
  }, [props.data.is_open]);

  return (
    <div
      className="modal fade"
      id="DeletePriceModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              {props.data.type == "price" ? "Deleted Prices" : "Deleted Tasks"}
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            {props.data.type == "price"
              ? props.data.value.map((value, d_index) => (
                <div className="border-bottom p-2" key={d_index}>
                 {value.free ? ( <h6>Price : Free </h6> ) : null}
                  {!value.free ? (
                    <div className="row pt-1">
                      <div className="col-6">
                        {/* <p><b className="text-dark">Rework Salary : </b>{value.rework_salary}</p> */}
                        <p>
                          <b className="text-dark">GST Percent : </b>
                          {value.gst_percent}
                        </p>
                        <p>
                          <b className="text-dark">HSN : </b>
                          {value.hsn}
                        </p>
                      </div>
                      <div className="col-6 text-end">
                        <p>
                          <b className="text-dark">Amount : </b>
                          {value.amount}
                        </p>
                        <p>
                          <b className="text-dark">GST Amount : </b>
                          {value.gst_amount}
                        </p>
                        <p>
                          <b className="text-dark">Total : </b>
                          {value.total_amount}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))
              : props.data.value.map((value, d_index) => (
                <div className="p-2" key={d_index}>
                  <div className="row pt-1">
                    <div className="col-6">
                      <p>
                        <b className="text-dark">Task Name : </b>
                        {value.task_name}
                      </p>
                      <p>
                        <b className="text-dark">Rework Salary : </b>
                        {value.rework_salary}
                      </p>
                    </div>
                    <div className="col-6 text-end">
                      <p>
                        <b className="text-dark">Deleted By : </b>
                        {value.deleted_user} @ {value.deleted_username}
                      </p>
                      <p>
                        <b className="text-dark">Deleted At : </b>
                        {value.deleted_at}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {/* <button type="button" className="btn btn-outline" onClick={(e) => { save(e) }} >
                            Save changes
                        </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
